import React from 'react';
import {
  AppBarComponent,
  AppBarItem,
  DropdownSection,
} from '@leagueplatform/web-common-components';
import { Image } from '@leagueplatform/genesis-commons';
import { APP_NAV_DEFAULT_HEIGHT } from 'common/constants';
import { NavLink } from 'hooks/use-nav-links-list.hook';
import { BrandingInfo } from 'hooks/use-get-app-init-details';
import { MobileNav } from './mobile-nav.component';

export const MobileNavbar: React.FC<{
  userDropdownConfig: DropdownSection[];
  navLinks: NavLink[];
  brandingInfo?: BrandingInfo;
}> = ({ userDropdownConfig, navLinks, brandingInfo }) => (
  <AppBarComponent navHeight={APP_NAV_DEFAULT_HEIGHT}>
    {brandingInfo?.brandingLogo && (
      <AppBarItem margin="auto">
        <Image
          loading="eager"
          height="oneAndHalf"
          role="presentation"
          alt="provider-logo"
          src={brandingInfo.brandingLogo}
        />
      </AppBarItem>
    )}

    {/* Spacer 2: Provides flexible space between nav links and dropdown */}
    <AppBarItem flexGrow={30} aria-hidden="true" />

    <AppBarItem>
      <MobileNav navLinks={navLinks} userDropdownConfig={userDropdownConfig} />
    </AppBarItem>

    {/* Spacer 3: Provides trailing space after dropdown */}
    <AppBarItem flexGrow={{ _: 1, laptop: 2 }} aria-hidden="true" />
  </AppBarComponent>
);
